import { render } from "./ViewIncoming.vue?vue&type=template&id=8cf584fc&scoped=true"
import script from "./ViewIncoming.vue?vue&type=script&lang=js"
export * from "./ViewIncoming.vue?vue&type=script&lang=js"

import "./ViewIncoming.vue?vue&type=style&index=0&id=8cf584fc&scoped=true&lang=css"

import exportComponent from "/Users/tinypocket/workspace/joysun/repositories/jb/jb-ems-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8cf584fc"]])

export default __exports__